import { useQuery } from '@tanstack/react-query';
import API from '@/apiRequest';

export const useInspectors = () => {
  const useInspectorsList = (options = {}) => useQuery({
    queryKey: ['inspectors'],
    queryFn: async () => {
      const { data } = await API.get('inspectors');
      return data;
    },
    ...options,
  });

  return {
    useInspectorsList,
  };
};
